export default "__VITE_ASSET__uvSxxPbd__"